import { Info } from "lucide-react"

export function BratislavaBannerNotice() {
  return (
    <div
      className="flex gap-3 rounded-[14px] border border-primary/30 px-5 py-4 mb-4"
      style={{ background: "color-mix(in srgb, var(--primary) 10%, transparent)" }}
    >
      <Info className="mt-0.5 size-5 shrink-0 text-primary" />
      <div className="flex flex-col gap-1">
        <p className="text-[14px] font-semibold text-foreground">
          Travelling to Bratislava? Every shuttle includes a Bratislava stop at no extra cost.
        </p>
      </div>
    </div>
  )
}
